export function getRegimeFacilitiesRoute(regimeId, share) {
    const path = `/app/facilities/${encodeURIComponent(regimeId)}`
    const params = new URLSearchParams()
    if (share) params.set("share", share)
    const search = params.toString()
    if (!search) return path
    return `${path}?${search}`
}
